export const state = () => ({
  title: '',
  description: '',
  keywords: '',
})

export const mutations = {
  UPDATE_META_TITLE(state, metaTitle) {
    state.title = metaTitle
  },
  UPDATE_META_DESCRIPTION(state, metaDescription) {
    state.description = metaDescription
  },
}

export const actions = {
  updateMetaData({ commit }, meta) {
    const { metaTitle, metaDescription } = meta

    commit('UPDATE_META_TITLE', metaTitle)
    commit('UPDATE_META_DESCRIPTION', metaDescription)
  },
}
